import { useMemo } from 'react'
import { CSVField } from 'hooks/useExportCSV'
import { csvColumnCreatedBy, csvColumnUpdatedBy } from 'features/UI'
import { formatDate } from 'utils'
import { createSummaryTagsColumnCSV } from 'features/Tags/models/TagsColumn'

export function useLearnLibraryCSVField() {
  return useMemo<CSVField[]>(
    () => [
      {
        label: 'Topic Name',
        value: 'name',
      },
      {
        label: 'Number of Articles',
        value: 'numberOfArticles',
      },
      createSummaryTagsColumnCSV('articles'),
      {
        label: 'Creation Date',
        value: ({ createdAt }) => formatDate(createdAt),
      },
      csvColumnCreatedBy(),
      {
        label: 'Last Edited',
        value: ({ updatedAt }) => formatDate(updatedAt),
      },
      csvColumnUpdatedBy(),
    ],
    [],
  )
}
